import FeedbackPostDrawer from '~modules/feedbackTool/containers/FeedbackPostDrawer'

export default function GlobalModals() {
  return <FeedbackPostDrawer />
}
